import { RouteObject } from 'react-router-dom';
import { LandingPage } from '../components/LandingPage';
import { SearchResults } from '../components/SearchResults';
import { PassengerForm } from '../components/PassengerForm';
import { PaymentForm } from '../components/PaymentForm';
import { Ticket } from '../components/Ticket';
import { ProfileScreen } from '../components/ProfileScreen';
import { SettingsScreen } from '../components/SettingsScreen';
import { MyTicketsScreen } from '../components/MyTicketsScreen';
import { TicketDetailScreen } from '../components/TicketDetailScreen';
import { LoginScreen } from '../components/LoginScreen';
import { AccountMenuScreen } from '../components/AccountMenuScreen';

/**
 * Configuración centralizada de rutas
 * Similar al routing de Angular
 */
export const routes: RouteObject[] = [
  {
    path: '/',
    element: <LandingPage />,
  },
  {
    path: '/login',
    element: <LoginScreen />,
  },
  {
    path: '/search',
    element: <SearchResults />,
  },
  {
    path: '/passengers',
    element: <PassengerForm />,
  },
  {
    path: '/payment',
    element: <PaymentForm />,
  },
  {
    path: '/ticket',
    element: <Ticket />,
  },
  {
    path: '/profile',
    element: <ProfileScreen />,
  },
  {
    path: '/settings',
    element: <SettingsScreen />,
  },
  {
    path: '/my-tickets',
    element: <MyTicketsScreen />,
  },
  {
    path: '/ticket-detail/:id',
    element: <TicketDetailScreen />,
  },
  {
    path: '/account',
    element: <AccountMenuScreen />,
  },
];

/**
 * Constantes de rutas para usar en navegación
 * Evita hardcodear strings en toda la app
 */
export const ROUTES = {
  HOME: '/',
  LOGIN: '/login',
  SEARCH: '/search',
  PASSENGERS: '/passengers',
  PAYMENT: '/payment',
  TICKET: '/ticket',
  PROFILE: '/profile',
  SETTINGS: '/settings',
  MY_TICKETS: '/my-tickets',
  TICKET_DETAIL: '/ticket-detail',
  ACCOUNT: '/account',
} as const;